import { ReactNode } from "react";
import { PublicNavbar } from "./PublicNavbar";
import Footer from "@/components/landing/Footer";
import { SkipLinks } from "@/components/ui/SkipLinks";

interface PublicLayoutProps {
  children: ReactNode;
}

export const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SkipLinks />
      <PublicNavbar variant="standard" />
      <main id="main-content" role="main" className="flex-1" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
};